var render, staticRenderFns
import script from "./MultiTab.vue?vue&type=script&lang=js&"
export * from "./MultiTab.vue?vue&type=script&lang=js&"
import style0 from "./MultiTab.vue?vue&type=style&index=0&id=469ff883&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ff883",
  null
  
)

export default component.exports